<template>
  <div class="wrapper">
    <div v-if="vehicles && vehicles.length">
      <div
        @click="$emit('onVehicleClick', item)"
        class="vehicle"
        v-for="item in vehicles"
        :key="item.contactVehicleId"
      >
        <app-image v-if="item.imageUrl"
          class="image"
          :imageUrl="item.imageUrl"
          :alt="'vehicle image'"
        ></app-image>
        <h1 class="title">{{ item.year }} {{ item.make }} {{ item.model }}</h1>
        <p class="subtitle" v-if="item.vin">
          VIN:&nbsp;<span>{{ item.vin }}</span>
        </p>
        <ul class="actions">
          <li v-if="item.ownerManualUrl">
            <a @click.stop="{}" :href="item.ownerManualUrl" target="_blank"
              ><span class="dbc-icon dbc-icon-document-header"></span>Get owners
              manual</a
            >
          </li>
          <li v-if="item.brochureUrl">
            <a @click.stop="{}" :href="item.brochureUrl" target="_blank"
              ><span class="dbc-icon dbc-icon-book"></span>Get brochure</a
            >
          </li>
          <li v-if="item.myVehicleWorth">
            <a
              href="#"
              @click.prevent.stop="$emit('whyMyCarWorth', item.myVehicleWorth)"
            >
              <span class="dbc-icon dbc-icon-tools"></span>What`s my vehicle
              worth?</a
            >
          </li>
          <li v-if="item.scheduleServiceLink">
            <a @click.stop="{}" :href="item.scheduleServiceLink" target="_blank"
              ><span class="dbc-icon dbc-icon-map_car-dealer"></span>Schedule
              service</a
            >
          </li>
        </ul>
      </div>
    </div>
    <no-vehicles v-else :vehiclesCategory="'purchased'"></no-vehicles>
  </div>
</template>

<script>
import NoVehicles from './no-vehicles.vue'
import AppImage from '../image.vue'
export default {
  name: 'garage-vehicles-list',
  props: {
    vehicles: {
      required: true,
      default: [],
      type: Array
    }
  },
  components: {
    NoVehicles,
    'app-image': AppImage
  },
  methods: {
    onWhatsMyCarWorth (url) {
      this.$emit('openModal', url)
    },
    onScheduleService (url) {
      this.$emit('openModal', url)
    }
  }
}
</script>

<style scoped>
.vehicle {
  margin-bottom: 24px;
}
.image {
  width: 100%;
}
.title {
  font-size: 22px;
  font-weight: bold;
  padding-bottom: 5px;
}
.subtitle {
  font-size: 16px;
  text-transform: uppercase;
  margin: 0 0 15px 0;
}
ul.actions > li {
  border-bottom: 1px solid rgba(33, 33, 33, 0.2);
  padding: 15px 0;
}
ul.actions > li > a {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #212121;
}
ul.actions > li > a > span.dbc-icon {
  color: #2c61d5;
  font-size: 1.6em;
  padding: 0;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// garage-vehicles-list.vue?093c99ef